"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { CookieService } from '@laurentgoudet/ngx-cookie';
import { Auth } from '@shared/auth';
import { Observable } from 'rxjs/Observable';
import { delay, mapTo, switchMap, tap } from 'rxjs/operators';
var Tracking = /** @class */ (function () {
    function Tracking(http, auth, cookies, config, platformId) {
        var _this = this;
        this.http = http;
        this.auth = auth;
        this.cookies = cookies;
        this.config = config;
        this.MAX_GET_LENGTH = 2000;
        this.sequenceNum = 0;
        if (!isPlatformBrowser(platformId)) {
            return;
        }
        var sessionId = this.cookies.get(this.config.sessionCookie);
        if (!sessionId) {
            // Generate a new one if not.
            sessionId = this.generateSessionId();
            this.cookies.put('_tracking_session', sessionId, {
                expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
            });
        }
        this.sessionId = sessionId;
        // send the event backlog if any
        try {
            var backlog = localStorage.getItem('trackingBacklog');
            if (backlog) {
                var itemsMap = JSON.parse(backlog);
                Object.values(itemsMap).forEach(function (item) {
                    _this.sendBeacon(item);
                });
            }
            localStorage.setItem('trackingBacklog', JSON.stringify({}));
        }
        catch (e) {
            // ignore the errors, e.g. quota is full or security error
            console.error(e);
        }
    }
    Tracking.prototype.track = function (eventName, eventData) {
        var _this = this;
        return this.auth.authState
            .pipe(switchMap(function (auth) {
            var e = __assign({
                acct: window.location.hostname.replace(/^www/, ''),
                t: Date.now().toString(),
                en: eventName,
                location: window.location.href,
                user_id: auth ? parseInt(auth.userId, 10) : undefined,
                session_id: _this.sessionId,
            }, eventData);
            return _this.sendBeacon(e);
        }))
            .toPromise();
    };
    Tracking.prototype.generateSessionId = function () {
        var s4 = function () {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        };
        return "" + s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
    };
    Tracking.prototype.sendBeacon = function (payload) {
        var _this = this;
        var beaconId = this.sequenceNum++;
        // save the event for later in case of a hard navigation
        try {
            var backlog = JSON.parse(localStorage.getItem('trackingBacklog') || '{}');
            backlog[beaconId] = payload;
            localStorage.setItem('trackingBacklog', JSON.stringify(backlog));
        }
        catch (e) {
            // ignore the errors, e.g. quota is full or security error
            console.error(e);
        }
        return Observable.of(payload)
            .pipe(
        // this prevents cancelling in-flight requests in case a user_action
        // event triggers a hard navigation
        delay(100), switchMap(function (e) { return _this.http.post(_this.config.trackingEndpoint, e); }), tap(function () {
            // Remove the event from the backlog once it has been sent
            try {
                var backlog2 = JSON.parse(localStorage.getItem('trackingBacklog') || '{}');
                delete backlog2[beaconId];
                localStorage.setItem('trackingBacklog', JSON.stringify(backlog2));
            }
            catch (e) {
                // ignore the errors, e.g. quota is full or security error
                console.error(e);
            }
        }), mapTo(undefined))
            .toPromise()
            .catch(function (err) {
            if (err.error instanceof Error) {
                // A client-side or network error occurred.
                throw err.error;
            }
            else {
                // The backend returned an unsuccessful response code
                throw err.message;
            }
        });
    };
    return Tracking;
}());
export { Tracking };



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/tracking/tracking.service.ts.pre-build-optimizer.js